import React from 'react';
import { Modal } from '@wordpress/components';
import logo from '../assets/logo.png';

interface CalculatorModalProps {
  isOpen: boolean;
  iFrameUrl: string;
  onClose: () => void;
}

export default function CalculatorModal({
  isOpen,
  iFrameUrl,
  onClose,
}: CalculatorModalProps): JSX.Element | null {
  if (!isOpen) return null;
  return (
    <Modal isFullScreen onRequestClose={onClose} __experimentalHideHeader>
      <div className="calculator-modal">
        <div className="calculator-modal-header">
          <div className="calculator-modal-header-left">
            <img src={logo} alt="Logo" className="calculator-logo" />
            <div className="calculator-modal-title">Convert_</div>
          </div>
          <button className="calculator-modal-close-button" onClick={onClose}>
            <span className="calculator-modal-close-icon">×</span>
          </button>
        </div>
        <div className="calculator-modal-iframe-container">
          <iframe
            src={iFrameUrl}
            title="Embedded Calculator"
            sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-modals"
            className="calculator-modal-iframe"
            key={iFrameUrl}
          />
        </div>
      </div>
    </Modal>
  );
}
